import request from '../../api/request';
import { Announcement } from './types';

const ENDPOINTS = {
  LIST: `teacher-portal/announcements`,
};

export const list = () => {
  return request<Announcement[]>(ENDPOINTS.LIST);
};
